import { Entitlements } from '@protector/entities/licensing/constants';
import { hasEntitlements } from '@protector/entities/licensing/utils';
import { getProtectorApp } from 'entities/company/company.selectors';
import { useRegionalOverviewStore } from '@features/regional-overview/regional-overview.store';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

interface IsRegionalOverviewDataMockResult {
  isLoaded: boolean;
  isRegionalOverViewMocked: boolean;
}

export const useRegionalOverviewMock = (): IsRegionalOverviewDataMockResult => {
  const { setIsDemo } = useRegionalOverviewStore();
  const protectorApp = useSelector(getProtectorApp);
  const isRegionalOverViewMocked = protectorApp ? hasEntitlements(protectorApp, [Entitlements.REGIONAL_RISK_MOCK]) : false;

  useEffect(() => {
    setIsDemo(isRegionalOverViewMocked);

    return () => {
      setIsDemo(false);
    };
  }, [isRegionalOverViewMocked, setIsDemo]);

  return {
    isLoaded: !!protectorApp,
    isRegionalOverViewMocked
  };
};
